const places = {
  saudiArabia: 'المملكة العربية السعودية',
  region: 'منطقة',
  governorate: 'محافظة',
  district: 'حي',
};

export default places;
